<section class="og-tile">
  <div class="og-tile__body">
    <header class="og-tile__header">
      <h4 class="og-tile__title">
        <a [routerLink]="vehicleDetailLink()">Order Guide</a>
      </h4>
    </header>

    <dl class="og-tile__rows">
    <div class="og-tile__row">
      <dt>Active Date</dt>
      <dd>
        <button type="button" class="og-tile__value-button" (click)="onEdit()">
          {{ activeDate() }}
        </button>
      </dd>
    </div>
    <div class="og-tile__row">
      <dt>Live Date</dt>
      <dd>{{ liveDate() }}</dd>
    </div>
    @if (showTranslationDate()) {
      <div class="og-tile__row">
        <dt>Send for Translation</dt>
        <dd>
          <button type="button" class="og-tile__value-button" (click)="onEdit()">
            {{ translationDate() }}
          </button>
        </dd>
      </div>
    }
    <div class="og-tile__row">
      <dt>SORP</dt>
      <dd>
        <button type="button" class="og-tile__value-button" (click)="onEdit()">
          {{ sorpDate() }}
        </button>
      </dd>
    </div>
    <div class="og-tile__row">
      <dt>Notes</dt>
      <dd>
        <button
          type="button"
          class="og-tile__value-button"
          [matTooltip]="notesTooltip()"
          [matTooltipDisabled]="!notesTooltip()"
          (click)="onEdit()">
          {{ notesPreview() }}
        </button>
      </dd>
    </div>
    <div class="og-tile__row">
      <dt>Attachments</dt>
      <dd>
        <button type="button" class="og-tile__value-button" (click)="onEdit()">
          {{ attachmentsPreview() }}
        </button>
      </dd>
    </div>
    </dl>
  </div>

  <div class="og-tile__actions">
    <button type="button" (click)="onCopyVehicle()">Copy Vehicle</button>
  </div>
</section>
